import { Pipe, PipeTransform } from '@angular/core';
import { UserChoiceTableDataItem } from '../model/user-choice-table-data-item';

@Pipe({
  name: 'filterUserChoices'
})
export class FilterUserChoicesPipe implements PipeTransform {
  transform(items: UserChoiceTableDataItem[], filter: string): any[] {
    if (!filter || filter.length == 0) {
      return items;
    }

    return items.filter(item =>
      Object.values(item).some(value => String(value).toLowerCase().includes(filter.toLowerCase()))
    );
  }
}
